module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', [_vm._s(_vm.msg)]), " ", " ", _vm._h('router-link', {
    staticClass: "pull-right icon-right orange",
    attrs: {
      "to": {
        path: '/remind/list'
      },
      "tag": "span"
    }
  }, ["提醒"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page ",
    class: {
      'roll-edit': _vm.callState == 2, 'roll-get': _vm.callState == 1
    },
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [_vm._m(0), " ", (_vm.callState == 1) ? [_vm._l((_vm.rollcallList), function(item) {
    return (item.studentList.length > 0) ? _vm._h('div', [_vm._h('span', {
      staticClass: "margin-15 block"
    }, [_vm._s(item.grade)]), " ", _vm._h('ul', {
      staticClass: "list-group-item bigger"
    }, [_vm._l((item.studentList), function(student) {
      return _vm._h('li', {
        staticClass: "list-group",
        on: {
          "click": function($event) {
            _vm.updateRollcallState($event, student)
          }
        }
      }, [_vm._h('div', {
        staticClass: "liner"
      }), " ", _vm._h('div', {
        staticClass: "group-link clearfix"
      }, [_vm._h('div', {
        staticClass: "img-wrap pull-left big"
      }, [_vm._h('img', {
        staticClass: "pull-left",
        attrs: {
          "src": student.imageAddress ? item.baseAcessPath + student.imageAddress : _vm.img_default,
          "width": "100%"
        }
      })]), " ", _vm._h('span', {
        staticClass: "group-txt",
        staticStyle: {
          "padding-top": "0"
        }
      }, [_vm._h('span', {
        staticClass: "block overhide"
      }, [_vm._h('cite', {
        staticClass: "font-16 pull-left"
      }, [_vm._s(student.studentName)]), " ", _vm._h('i', {
        staticClass: "img-sex",
        class: {
          'boy': student.sex == '男', 'girl': student.sex == '女'
        }
      }, [_vm._s(student.sex)])]), " ", (student.callState == 1) ? _vm._h('span', {
        staticClass: "block gray"
      }, [_vm._s(student.callTime)]) : _vm._e(), " ", (!student.parentRole) ? _vm._h('span', {
        staticClass: "gray"
      }, ["待家长确认"]) : _vm._e(), " ", (student.parentRole) ? _vm._h('span', {
        staticClass: "green"
      }, ["家长已确认"]) : _vm._e()]), " ", (!student.parentRole && !_vm.isBefore) ? _vm._h('span', {
        staticClass: "no-get"
      }, [_vm._h('a', {
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.isHideRollcallNo = false, _vm.setStudentDialog(student, item.baseAcessPath, item.grade)
          }
        }
      }, ["未接回"])]) : _vm._e()])])
    })])]) : _vm._e()
  })] : _vm._e(), " ", (_vm.callState == 2) ? [_vm._l((_vm.rollcallList), function(item) {
    return (item.studentList.length > 0) ? _vm._h('div', [_vm._h('span', {
      staticClass: "margin-15 block"
    }, [_vm._s(item.grade)]), " ", _vm._h('ul', {
      staticClass: "list-group-item bigger"
    }, [_vm._l((item.studentList), function(student) {
      return _vm._h('li', {
        staticClass: "list-group"
      }, [_vm._h('div', {
        staticClass: "liner"
      }), " ", _vm._h('div', {
        staticClass: "group-link clearfix"
      }, [_vm._h('div', {
        staticClass: "img-wrap big pull-left"
      }, [_vm._h('img', {
        attrs: {
          "src": student.imageAddress ? item.baseAcessPath + student.imageAddress : _vm.img_default,
          "width": "100%"
        }
      })]), " ", _vm._h('span', {
        staticClass: "group-txt"
      }, [_vm._h('span', {
        staticClass: "block overhide"
      }, [_vm._h('cite', {
        staticClass: "font-16 pull-left"
      }, [_vm._s(student.studentName)]), " ", _vm._h('i', {
        staticClass: "img-sex",
        class: {
          'boy': student.sex == '男', 'girl': student.sex == '女'
        }
      }, [_vm._s(student.sex)])]), " ", _vm._h('cite', {
        staticClass: "gray"
      }, [_vm._s(item.grade) + _vm._s(student.className) + _vm._s(student.typeName ? '（' + student.typeName + '）' : '')])]), " ", (student.callState == 2) ? _vm._h('span', {
        staticClass: "pull-right"
      }, [_vm._h('a', {
        staticClass: "button-roll",
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.isHideRollcallOk = false, _vm.setStudentDialog(student, item.baseAcessPath, item.grade)
          }
        }
      }, ["接回"])]) : _vm._e()])])
    })])]) : _vm._e()
  })] : _vm._e()]), " ", _vm._h('div', {
    staticClass: "bottom-bar"
  }, [_vm._h('div', {
    staticClass: "tabs"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('ul', {
    staticClass: "clearfix text-center font-14"
  }, [_vm._h('li', {
    staticClass: "col-xs-6",
    class: {
      'active': _vm.callState == 2
    },
    on: {
      "click": function($event) {
        _vm.callState = 2, _vm.getCallList()
      }
    }
  }, [_vm._h('span', ["未接回（" + _vm._s(_vm.wdd) + "）"])]), " ", _vm._h('li', {
    staticClass: "col-xs-6",
    class: {
      'active': _vm.callState == 1
    },
    on: {
      "click": function($event) {
        _vm.callState = 1, _vm.getCallList()
      }
    }
  }, [_vm._h('span', ["已接回（" + _vm._s(_vm.ydd) + "）"])])])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideRollcallOk),
      expression: "!isHideRollcallOk"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideRollcallOk = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap pop-parents"
  }, [_vm._h('div', {
    staticClass: "clearfix margin-x-15"
  }, [_vm._h('div', {
    staticClass: "pull-left"
  }, [_vm._h('img', {
    staticClass: "rounded-60",
    attrs: {
      "src": _vm.studentDialog.imageAddress ? _vm.studentDialog.baseAcessPath + _vm.studentDialog.imageAddress : _vm.img_default,
      "width": "60",
      "height": "60"
    }
  })]), " ", _vm._h('div', {
    staticClass: "pull-left padding-10 margin-x-15"
  }, [_vm._h('p', {
    staticClass: "font-16 clearfix"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, [_vm._s(_vm.studentDialog.studentName)]), " ", _vm._h('span', {
    staticClass: "pull-left img-sex",
    class: {
      'boy': _vm.studentDialog.sex == '男', 'girl': _vm.studentDialog.sex == '女'
    }
  })]), " ", _vm._h('p', {
    staticClass: "gray"
  }, [_vm._s(_vm.studentDialog.grade) + _vm._s(_vm.studentDialog.className) + _vm._s(_vm.studentDialog.typeName ? '（' + _vm.studentDialog.typeName + '）' : '')])])]), " ", _vm._h('p', {
    staticClass: "text-center padding-15"
  }, ["确定要更改为“ 已接回 ”吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-x-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix text-center"
  }, [_vm._h('div', {
    staticClass: "col-xs-6"
  }, [(_vm.upd_status_para.isLoading == false) ? _vm._h('a', {
    staticClass: "blue block padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updStatus(1)
      }
    }
  }, [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "border-right": "1px solid #e3e3e3"
    }
  }, ["确定"])]) : _vm._h('a', {
    staticClass: "blue block padding-15"
  }, [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "border-right": "1px solid #e3e3e3"
    }
  }, ["确定"])]), " "]), " ", _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('a', {
    staticClass: "blue block padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideRollcallOk = true
      }
    }
  }, [_vm._h('span', {
    staticClass: "block"
  }, ["取消"])])])])])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideRollcallNo),
      expression: "!isHideRollcallNo"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideRollcallNo = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap pop-parents"
  }, [_vm._h('div', {
    staticClass: "clearfix margin-x-15"
  }, [_vm._h('div', {
    staticClass: "pull-left"
  }, [_vm._h('img', {
    staticClass: "rounded-60",
    attrs: {
      "src": _vm.studentDialog.imageAddress ? _vm.studentDialog.baseAcessPath + _vm.studentDialog.imageAddress : _vm.img_default,
      "width": "60",
      "height": "60"
    }
  })]), " ", _vm._h('div', {
    staticClass: "pull-left padding-10 margin-x-15"
  }, [_vm._h('p', {
    staticClass: "font-16 clearfix"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, [_vm._s(_vm.studentDialog.studentName)]), " ", _vm._h('span', {
    staticClass: "pull-left img-sex",
    class: {
      'boy': _vm.studentDialog.sex == '男', 'girl': _vm.studentDialog.sex == '女'
    }
  })]), " ", _vm._h('p', {
    staticClass: "gray"
  }, [_vm._s(_vm.studentDialog.grade) + _vm._s(_vm.studentDialog.className) + _vm._s(_vm.studentDialog.typeName ? '（' + _vm.studentDialog.typeName + '）' : '')])])]), " ", _vm._h('p', {
    staticClass: "text-center padding-15"
  }, ["确定要更改为“ 未接回 ”吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-x-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix text-center"
  }, [_vm._h('div', {
    staticClass: "col-xs-6"
  }, [(_vm.upd_status_para.isLoading == false) ? _vm._h('a', {
    staticClass: "blue block padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updStatus(2)
      }
    }
  }, [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "border-right": "1px solid #e3e3e3"
    }
  }, ["确定"])]) : _vm._h('a', {
    staticClass: "blue block padding-15",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "border-right": "1px solid #e3e3e3"
    }
  }, ["确定"])]), " "]), " ", _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('a', {
    staticClass: "blue block padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideRollcallNo = true
      }
    }
  }, [_vm._h('span', {
    staticClass: "block"
  }, ["取消"])])])])])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "bg-white padding-15 font-12",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._h('span', {
    staticClass: "block font-16"
  }, ["温馨提示:"]), " ", _vm._h('p', {
    staticClass: "gray",
    staticStyle: {
      "margin-top": "5px"
    }
  }, ["点击右上角 “", _vm._h('span', {
    staticClass: "orange"
  }, ["提醒"]), "” 可以设置定时推送消息，到设定时间后，系统会自动推送一条消息给家长，提醒家长及时接回孩子！"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-c8b791a0!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/rollcall/rollcallHand.vue
// module id = 224
// module chunks = 1